import React, { useEffect, useRef, useState } from "react";

import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import de from "date-fns/locale/de";

import Footer from "./Footer";
import HotNews from "./HotNews";
import Platzbelegung from "./Platzbelegung";

import { _common } from "../common";
import PlatzbelegungPage2 from "./PlatzbelegungPage2";
import Welcome from "./welcome/Welcome";
const common = _common;

registerLocale("de", de);


function ResolutionTest() {
  const resolutionTest: any = [];

  for (let i = 0; i < 1920 / 4 / 2; i++) {
    resolutionTest.push(<div style={{ position: "absolute", left: `${i * 2}px`, height: "100px", width: "2px", backgroundColor: "red", borderLeft: "1px solid Green" }}></div>);
  }

  resolutionTest.push(<div style={{ width: `480px`, height: "200px" }}>xx</div>);

  for (let i = 0; i < 1920 / 4 / 10; i++) {
    resolutionTest.push(<div style={{ height: "100px", width: "9px", backgroundColor: "yellow", borderLeft: "1px solid Green" }}></div>);
  }

  for (let i = 0; i < 1920 / 4 / 10; i++) {
    resolutionTest.push(<div style={{ height: "100px", width: "9px", backgroundColor: "blue", borderLeft: "1px solid Green" }}></div>);
  }

  for (let i = 0; i < 1920 / 4 / 10; i++) {
    resolutionTest.push(<div style={{ height: "100px", width: "9px", backgroundColor: "orange", borderLeft: "1px solid Green" }}></div>);
  }
  return <div style={{ position: "absolute", left: "0px", top: "0px", display: "flex", flexDirection: "row", zIndex: "10" }}>{resolutionTest}</div>;
}

function BlackScreen(props: {}) {
  return (
    <div style={{ position: "absolute", left: "0px", top: "0px", width: "100vw", height: "100vw", backgroundColor: "black" }}>
      <div style={{ color: "#444" }}>Nachtabschaltung aktiv</div>
    </div>
  );
}

export default function MainAnzeigeTafel2() {
  const d1 = new Date();
  const d2 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
  const [startDate, setStartDate] = useState<Date>(d2);
  const [redraw, setRedraw] = useState(1);

  const PlatzbelegungPage1Ref = useRef<HTMLDivElement>(null);

  const scrollPos = useRef<number>(0);

  function onRedraw() {
    const x = new Date().getTime();
    scrollPos.current = window.scrollY;
    setRedraw(x);
  }

  useEffect(() => {
    window.scrollTo(0, scrollPos.current);
  });

  useEffect(() => {
    const viewport = document.querySelector("meta[name=viewport]");
    if (viewport) {
      viewport.setAttribute("content", "width=1920");
    }
    const interval = window.setInterval(() => {
      const d1 = new Date();
      const d2 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
      setStartDate(d2);
      onRedraw();
    }, 2 * 60 * 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  console.log("render anzeigenTafel", startDate);

  const TopStyle: any = {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    marginTop: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    backgroundColor: "#fff",
    width: "33vw",
    height: "100%",
    overflow: "hidden",
    borderRadius: "10px",
    border: "1px solid grey",
  };

  // common.heightHour = 150 * common.globalScale;

  common.firstHourOfDay = 7;
  common.lastHourOfDay = 22;

  const now = new Date();
  if (now.getHours() < 7 || now.getHours() > 21) {
    return <BlackScreen />;
  }

  return (
    <div style={{ display: "flex", flexDirection: "row", width: "100vw", height: "100vh", gap: "10px", overflow: "hidden", backgroundColor: "black", padding: "10px" }}>
      {/* <ResolutionTest /> */}

      <div key="welcome" id="welcome" style={TopStyle}>
        {redraw && <Welcome />}
      </div>

      <div ref={PlatzbelegungPage1Ref} key="belegung" id="belegung" style={TopStyle}>
        {redraw && (
          <div
            id="innerMain"
            style={{
              width: "100%",
              position: "relative",
              display: "flex",
              flexDirection: "column",
              height: "max-content",
            }}
          >
            <Platzbelegung startDate={startDate} onReDraw={onRedraw} />

            {common.anzeigeTafelMode && <HotNews />}

            <Footer />
          </div>
        )}
      </div>

      <div key="web" id="web" style={TopStyle}>
        <PlatzbelegungPage2 />
      </div>
    </div>
  );
}
